import React, { useEffect } from "react";
import { Box, Button, Modal, Typography, TextField } from "@mui/material";
import { Container } from "@mui/system";

import { useAssignment, useSetAssignment } from "../../globals/AssignmentContext";
import { createAssignmentAction } from "../../actions/createAssignment";
import { copyAssignmentAction } from "../../actions/copyAssignment";
import { addAssignmentAction } from "../../actions/addAssignment";
import { useUser } from "../../globals/UserContext";
import Assignment from "./Assignment";
import AssignmentPickerList from "./AssignmentPickerList";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 500,
    height: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

export default function AssignmentPicker(props) {
  const setAssignment = useSetAssignment();
  const { user } = props;
  const { classroom } = props;

  const { handleAssignmentPicked } = props

  const handlePick = (assignmentID) => {
    handleAssignmentPicked(assignmentID)
  }

  const assignments = !props.copy ? (
    user?.assignments?.filter(x => !classroom?.assignments?.includes(x._id) && !classroom?.assignments?.includes(x) )
  ) : (
    user?.assignments
  )

  return (
    props.open ? (
    <Box sx={modalStyle}>
      <Typography id="modal-modal-title" variant="h5" component="h2" textAlign="center">
        Pick an assignment
      </Typography>
      {assignments?.map((assignment) => <AssignmentPickerList variant="h6" handlePick={handlePick} key={(typeof assignment === "string") ? assignment : assignment._id} assignment={assignment}></AssignmentPickerList>)}
    </Box>
    ) : (
      <></>
    )
  )
}